// Layout.jsx
import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import "../../styles/Layout.css";

const Layout = ({ children, onLogout, isAdmin }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Close sidebar when window resizes to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && mobileOpen) {
        setMobileOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileOpen]);

  return (
    <div className="d-flex flex-column vh-100">
      <Header
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        onLogout={onLogout}
      />
      <div className="d-flex flex-grow-3 overflow-hidden position-relative">
        <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} isAdmin={isAdmin} />
        <main className="main-content flex-grow-1 p-1">
          {children}
        </main>
        {mobileOpen && (
          <div
            className="sidebar-overlay"
            onClick={() => setMobileOpen(false)}
          ></div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;